import { render, staticRenderFns } from "./serviceori.vue?vue&type=template&id=740e3168&scoped=true&"
import script from "./serviceori.vue?vue&type=script&lang=js&"
export * from "./serviceori.vue?vue&type=script&lang=js&"
import style0 from "./serviceori.vue?vue&type=style&index=0&id=740e3168&prod&lang=scss&"
import style1 from "./serviceori.vue?vue&type=style&index=1&id=740e3168&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "740e3168",
  null
  
)

export default component.exports